import { app } from '../../../bootstrap/core';
import { confirmAuthorizationComponent } from './confirmAuthorization.component';
import { AcceptanceReasons } from './confirmAuthorization.values';

app.component('confirmAuthorization', confirmAuthorizationComponent);
app.value('acceptanceReasons', AcceptanceReasons);
